import type { TargetingTermValueInput } from '../../../../../../../../apis/graphql';
import type { TargetingTermValue } from '../../../../../../../../models';
import type { TargetingResult } from '../types';
import type { GetMergedOldAndNewTargetingParams, GetTargetingResult, GetTargetingValuesParams } from './types';

export const getTargetingValues = ({ formTargeting }: GetTargetingValuesParams): TargetingResult => {
  return formTargeting.reduce<TargetingResult>(
    (acc, currentTarget) => {
      if (currentTarget.include) {
        return { ...acc, include: [...acc.include, currentTarget.value.displayName] };
      }
      if (!currentTarget.include) {
        return { ...acc, exclude: [...acc.exclude, currentTarget.value.displayName] };
      }

      return acc;
    },
    { include: [], exclude: [] }
  );
};

export const transformTargetingTermValues = (targetingTermValues: TargetingTermValue[]): TargetingTermValueInput[] =>
  targetingTermValues.map(({ include, dimension, value }) => ({
    include,
    dimensionName: dimension.id,
    valueName: value.id,
  }));

export const getTransformedExistedTargeting = (
  existedTargeting?: Record<string, TargetingTermValue[]>
): GetTargetingResult =>
  existedTargeting
    ? Object.keys(existedTargeting).map((entityId) => ({
        id: entityId,
        value: transformTargetingTermValues(existedTargeting[entityId]),
      }))
    : [];

export const getMergedOldAndNewTargeting = ({
  inputTargeting,
  existedTargeting,
}: GetMergedOldAndNewTargetingParams): GetTargetingResult => {
  const transformed = getTransformedExistedTargeting(existedTargeting);

  return inputTargeting.map((newTargeting) => {
    const findOldTargeting = transformed?.find((item) => item.id === newTargeting.id) || null;

    const oldTargetingValues = findOldTargeting ? findOldTargeting.value : [];

    return {
      id: newTargeting.id,
      value: [...newTargeting.value, ...oldTargetingValues],
    };
  });
};
